export const languageElements = {
  items: {
    "div-LoggedUser": {
      hu: "Kilépés",
      de: "Logout",
      en: "Logout",
    },
  },
};
